import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";

import classNames from "classnames";

type Props = {};

const RenderLoading = (props: Props) => {
  return (
    <div className={classNames("report-loading")}>
      <div className="card h-full row">
        <div className="col-12 h-16">
          <div className="row">
            <div className="col-12">
              <Skeleton variant="rectangular" width="15%" height={40} />
            </div>
            <div className="col-12 mt-5">
              <Skeleton variant="rectangular" width="100%" height={1} />
            </div>
          </div>
        </div>
        <div className="col-12 h-20 mt-12">
          <div className="row justify-between">
            <div className="col-3">
              <Skeleton variant="rectangular" width="100%" height={80} />
            </div>
            <div className="col-6">
              <Skeleton variant="rectangular" width="100%" height={40} />
            </div>
          </div>
        </div>

        <div className="col-12 mt-20 row">
          <div className=" flex justify-between items-center col-12 mb-10">
            <Skeleton variant="rectangular" width="40%" height={40} />
            <Skeleton variant="rectangular" width="20%" height={40} />
          </div>
          <TableContainer component={Paper} className="shadow-lg rounded-lg">
            <Table>
              <TableHead className="bg-gray-200">
                <TableRow>
                  <TableCell sx={{ width: "250px" }}>
                    <Skeleton width="90%" />
                  </TableCell>
                  <TableCell sx={{ width: "150px" }}>
                    <Skeleton width="90%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="80%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="80%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="90%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="80%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="90%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="80%" />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.from({ length: 8 }).map((_, index) => (
                  <TableRow key={index} className="hover:bg-gray-100">
                    <TableCell>
                      <Skeleton width="90%" />
                    </TableCell>
                    <TableCell>
                      <Skeleton width="85%" />
                    </TableCell>
                    <TableCell>
                      <Skeleton width="75%" />
                    </TableCell>
                    <TableCell>
                      <Skeleton width="70%" />
                    </TableCell>
                    <TableCell>
                      <Skeleton width="85%" />
                    </TableCell>
                    <TableCell>
                      <Skeleton width="70%" />
                    </TableCell>
                    <TableCell>
                      <Skeleton width="85%" />
                    </TableCell>
                    <TableCell>
                      <Skeleton variant="rectangular" width="50%" height={30} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
};

export default RenderLoading;
